import { Vehicle, VehicleType } from "./vehicle.type";
import { Waste } from "./waste.type";
import { TransportSedelGroup } from "api/transportSedel.api";
import { TransportSedel, TransportSedelStatus } from "./transportSedel.type";

export enum HasSentStatus {
  Sent = "Sent",
  NotSent = "NotSent",
  Ignored = "Ignored",
  SentWithOtherInspection = "SentWithOtherInspection",
  NotApplicable = "NotApplicable",
}

const sumPreliminaryWeight = (td: TransportSedel) =>
  td.wasteList.reduce((sum, waste) => sum + +waste.weightPreliminary, 0);

export const sumPreliminaryTotalWeight = (tds: TransportSedel[]) =>
  tds.reduce((sum, td) => sum + sumPreliminaryWeight(td), 0);

export const activeTransportSedels = (
  truckSelected: boolean,
  trailerSelected: boolean,
  group?: TransportSedelGroup,
) => {
  if (!group) return [];
  if (group.vehicles.length === 0) throw Error("No vehicles in group");
  if (group.vehicles.length === 1)
    return group.vehicles[0].transportSedelList.filter(
      (td) => td.status === TransportSedelStatus.LoadedOnTruck,
    );

  const result = [];
  if (truckSelected) {
    const truck = group.vehicles.find(
      (v) => v.vehicle.type === VehicleType.Truck,
    );
    if (!truck) throw Error("No truck in group");
    result.push(...truck.transportSedelList);
  }
  if (trailerSelected) {
    const trailer = group.vehicles.find(
      (v) => v.vehicle.type === VehicleType.Trailer,
    );
    if (!trailer) throw Error("No trailer in group");
    result.push(...trailer.transportSedelList);
  }
  return result.filter(
    (td) => td.status === TransportSedelStatus.LoadedOnTruck,
  );
};

export const getWasteFromTransportSedelList = (
  transportSedelList: TransportSedel[],
): Waste[] => {
  const result: Waste[] = [];
  for (const document of transportSedelList) {
    const wasteList = document.wasteList.map((waste) => ({
      ...waste,
      transportSedel: document,
    }));
    result.push(...wasteList);
  }
  return result;
};

export const getVehicleFromGroups = (
  id: number,
  groups: TransportSedelGroup[],
): Vehicle => {
  for (const group of groups) {
    for (const vehicle of group.vehicles) {
      if (vehicle.vehicle.id === id) return vehicle.vehicle;
    }
  }
  throw Error("No vehicle with id " + id);
};
